import React from 'react'
import { NotificationForm } from './logic/NotificationForm'

export const NotificationCreate = () => {
  return (
    <>
        <NotificationForm mode={'create'} notificationId={null}/>
    </>
  )
}
